// AUTH SERVICE
export const SIGN_UP_ENDPOINT = 'integration/customers';
export const LOGIN_ENDPOINT = 'integration/customer/token';
export const SEND_OTP_ENDPOINT = 'mobile-login/send-otp';
export const VERIFY_OTP_ENDPOINT = 'mobile-login/verify-otp';
export const SAVE_PROFILE_ENDPOINT = 'mobile-login/save-profile';
export const PROFILE_ENDPOINT = 'customers/me';
export const STATES_ENDPOINT = 'directory/countries/IN';
export const ADDRESS_ENDPOINT = `customer/address`;
export const VALIDATE_VPA_RAZORPAY =
  'https://api.razorpay.com/v1/payments/validate/vpa';

// PRODUCTS
export const PRODUCT_ATTRIBUTES = `products/attributes`;
export const PRODUCT_CONFIGURABLE = `configurable-products`;
export const PRODUCT_CATEGORIES = `categories`;
export const PRODUCT = `products`;
export const GET_FILTERED_CATEGORIES = 'categories/list';
export const CHECK_PRODUCT_PINCODE = `postcode`;
export const WISHLIST = 'wish-list';
export const LIFESTYLE_OPTIONS = `/lifestyle/options`;
export const ADDITIONAL_FILTER_OPTIONS = `/additional_filters/options`;
export const TEXTURE_FILTER_OPTIONS = `/texture/options`;
export const FLAVOUR_FILTER_OPTIONS = `/flavour/options`;
export const IDENTIFIER_OPTIONS = `/identifier/options`;
export const STOCK_ITEMS = 'stockItems';
export const INVENTORY = 'inventory';

// CART
export const GUEST_CART = `guest-carts`;
export const CUSTOMER_CART = `carts/mine`;
export const CUSTOMER_CART_MINE = `cart/mine`;
export const GET_CATEGORIES = 'categories';
export const TIMESLOT = 'timeslot';
export const DELIVERY_METHODS = 'estimate-shipping-methods';
export const BILLING_ADDRESS = `carts/mine/billing-address`;
export const SHIPPING_METHODS = `shipping-methods`;
export const SWITCH_CUSTOMER_CART = `switch-cart-to-guest`;

// USER
export const LOGGED_IN_USER = 'me';

//ORDERS
export const GET_ORDER_HISTORY = `${LOGGED_IN_USER}/orders`;
export const GET_KS_EVENTS_HISTORY = `${LOGGED_IN_USER}/event/orders`;
export const GET_IN_STORE_ORDER_HISTORY = 'offlineproduct?searchCriteria';
export const GET_GUEST_ORDER_HISTORY = `${GUEST_CART}/orders`;
export const GET_GUEST_KS_EVENTS_ORDER_HISTORY = `${GUEST_CART}/event/orders`;
export const USER_CANCEL_ORDER = `${LOGGED_IN_USER}/orders`;
export const GUEST_CANCEL_ORDER = `${GUEST_CART}/orders`;

// GENERAL
export const IMAGE_URI = '/media/catalog/product';
export const GRAPHQL_URI = 'graphql';
export const EXPRESS_STANDARD_CHECK_SERVICEABILITY =
  'expressstandard/check-serviceability';

//RECIPES
export const RECIPES = `products`;

// STORE
export const STORE_INFO = 'store/info';
export const STORE_LIST = 'stores';

//LANDING BANNER ENDPOINTS
export const CMS_PAGE = 'cmspage/';
export const GIFTING_LANDING = 'gift-landing';
export const MOTHERS_DAY_LANDING = 'mothers-day-landing';
export const FATHERS_DAY_LANDING = 'fathers-day-landing';
export const MANGO_GIFTING = 'mango-gifting';
export const FRUITS_VEGETABLES = 'fruits-vegetables';
export const RAMZAN_LANDING = 'ramzan-landing';
export const GIFTING_PAGE_MIDDLE_BANNER = 'gifting-page-middle-banner';
export const BULK_GIFTING_FORM_PAGE = 'bulk-gifting-form-page';
export const ABOUT_US_LANDING = 'about-us';
export const KITCHEN_STUDIO_LANDING = 'kitchen-studio';
export const YOUR_SHELF_LANDING = 'your-shelf';
export const STORIES_LADNING = 'stories';
export const RECIPES_LANDING = 'recipes';
export const SERVICES_LADNING = 'services';
export const STORIES_DISCOVER_LANDING = 'stories-discover-all';
export const CONTACT_US_LANDING = 'contact-us';
export const SHELF_LANDING = 'shelf';
export const PERSONAL_SHOPPER_LANDING = 'personal-shopper';
export const GIFTING_PLP = 'gifting-plp';
export const COME_WRITE_YOURS_LANDING = 'come-write-yours';
export const CHEESE_PLATTER_LANDING = 'cheese-platter';
export const FAQ_LANDING = 'faq';
export const CMS_BANNER_ENDPOINT = '/media/cmsbanner/';
export const CMS_BANNER_MOBILE_ENDPOINT = '/media/cmsmobilebanner/';
export const PAGE_BANNER_PATH = '/media/dss/landingbanner/';
export const GIFT_MESSAGES = 'giftmessage';
export const GIFTING_PRODUCTS_BG_IMAGE_URI = '/media/cmsproductsbg/';
export const GIFTING_PRODUCTS_BG_IMAGE_MOBILE_URI =
  '/media/cmsproductsbgmobile/';
export const GIFTING_MARKETING_BANNER_IMAGE_URI =
  '/media/Gifting_Marketing_Banner_Web.jpg';
export const GIFTING_MARKETING_BANNER_IMAGE_MOBILE_URI =
  '/media/Gifting_marketing_Banner_Mobile.jpg';
export const GIFTHAMPER_IMAGE_URI = '/gifthamper/occasion/';
export const GIFTING_ATTRIBUTES_FESTIVAL = 'products/attributes/festival';
export const GIFTING_ATTRIBUTES_OCCASSION = 'products/attributes/occasion';
export const GIFTING_CURATED_MESSAGES = 'greeting/card/messages';
export const WEEKEND_OF_PLENTY = 'weekend-of-plenty';
export const WEEKEND_OF_PLENTY_MID_BANNER = 'weekend-of-plenty-middle-banner';

// GLOBAL
export const BANNER_IMAGES = 'banner/list';
export const BANNER_IMAGE_DATA = 'banner/data';
export const CUSTOMER_SUBSCRIBE = 'customer/subscribe';
export const PAGE_TICKERS = 'page/notification';
export const BANNER_ENDPOINT = 'banner/data';
export const FAVOURITES = 'customer/frequent-order-items';
export const RAMZAN_SPECIAL = 'ramzan-special';
export const FATHERS_DAY = 'fathers-day';

// FORM
export const PERSONAL_SHOPPER = 'customform/personal-shopper';
export const CHEESE_PLATTERS = 'customform/cheese-platters';
export const BESPOKE_ORDERS = 'customform/getintouch-bespoke-order';
export const WEEKEND_OF_PLENTY_FORM = 'customform/weekend-of-plenty';
export const MANGO_BESPOKE_ORDERS = 'customform/getintouch-mango-bespoke-order';
export const BULK_ORDERS = 'customform/getintouch-bulk-order';
export const RENT_KITCHEN_BUSINESS = 'customform/rent-kitchen-business';
export const RENT_KITCHEN_PERSONAL = 'customform/rent-kitchen-personal';
export const CONTACT_US = 'customform/contact-us';
export const COME_WRITE_YOURS = 'customform/come-write-yours';
export const FORM_FIELDS = 'form';

//FAQS
export const FAQ_OPTIONS = '/faqs/faq-options.json';
export const KITCHEN_STUDIO_FAQS = 'kitchen-studio-and-events';

//EVENTS
export const CREATE_EVENT = 'event/order';
export const CREATE_GUEST_EVENT = 'event/guest/order';
export const EVENT_INVOICE = 'event/invoice';
export const GUEST_EVENT_INVOICE = 'event/guest/invoice';
export const GET_GUEST_EVENT_ORDER_HISTORY = `${GUEST_CART}/event/orders`;
export const BOOK_FREE_EVENT = 'book-free-event';

//KITCHEN STUDIO
export const CREATE_STUDIO_BOOKING = 'booking/studio';
export const CREATE_GUEST_STUDIO_BOOKING = 'booking/guest/studio';
export const BOOKING_AVAILABILITY = 'booking';

//RAZORPAY ENDPOINTS
export const GET_RAZORPAY_CUSTOMER_ID = 'customer/razorpay';
export const GET_RAZORPAY_CUSTOMER_SAVED_TOKENS = 'customer/razorpay/card';

//SERVICEABILITY
export const GET_GOOGLE_REVERSE_GEOCODE = 'google/reverse-geocode';
export const GET_GOOGLE_PLACE_DETAILS = 'google/place-detail';
export const GET_STORE_NEARBY = 'store/nearby';

// BRANDS
export const TRUSTED_BY_BRANDS = 'trusted';

// GIFTING
export const GET_GIFTING_BOXES = `products?searchCriteria[filter_groups][0][filters][0][field]=attribute_set_id&searchCriteria[filter_groups][0][filters][0][value]=${process.env.GIFTING_BOXES_ATTRIBUTE_SET_ID}&searchCriteria[pageSize]=100&searchCriteria[filter_groups][1][filters][0][field]=status&searchCriteria[filter_groups][1][filters][0][value]=1`;
